import { defineStore } from "pinia";
import { DashboardAuth, TypeDataUserAuth } from "../Auth/dashboardAuth";
import { getIndexedDB, setIndexedDB } from "@/dataSource/indexed-DB/indexedDB";
import { removeCodeMobile } from "../RemoveCodeMobile";
import { StorageUrl } from "@/dataSource/axios";
import { GET_PROFILE, POST_PROFILE_UPDATE } from "@/dataSource/api/user/apiAuth";
import { PopupType, Popups } from "../Popup";
import { POST_UPLOAD } from "@/dataSource/api/upload/apiUpload";
import { ContactList } from "../Contact/listContact";


type DataProfile = {
    ID: Number,
    firstName: String,
    lastName: String,
    mobile: any,
    secondPhone: any,
    homePhone: any,
    job: String,
    avatar: any
    workPhone: any
}

interface errUpload {
    showCardCroper: boolean
    errMessage: string
}

interface TypeUploadAvatar {
    SIDAvatar: string
    loading: boolean
    srcphoto: string
    changeAvatar: boolean
    srcCroper: any
    showCroper: boolean
    result: any
    formData: any
    errMessageCroper: errUpload
}

type errMessage = {
    errMessage: string
    showCardMessage: Boolean
}
type successMessage = {
    successMessage: string
    showCardMessage: Boolean
}

interface TypeDateEditProfile {
    dataProfile: DataProfile
    loading: boolean
    dataPopup: PopupType
    dataUserAuth: any
    dataListContact: any
    uploadAvatar: TypeUploadAvatar
    result: any
    updateProfile: any
    formData: any
    regex: any
    err: errMessage
    success: successMessage
}



export const EditProfile = defineStore('EditProfile', {
    state: () => <TypeDateEditProfile>({
        dataUserAuth: DashboardAuth(),
        dataPopup: Popups(),
        loading: false,
        dataProfile: {
            ID: NaN,
            firstName: '',
            lastName: '',
            mobile: '',
            secondPhone: '',
            homePhone: '',
            job: '',
            avatar: '',
            workPhone: ''
        },
        uploadAvatar: {
            SIDAvatar: '',
            srcCroper: '',
            srcphoto: '',
            loading: false,
            changeAvatar: true,
            loadingCroper: false,
            showCroper: false,
            formData: new FormData(),
            result: [],
            errMessageCroper: {
                showCardCroper: false,
                errMessage: ''
            }
        },
        err: {
            errMessage: '',
            showCardMessage: false
        },
        success: {
            successMessage: '',
            showCardMessage: false
        },
        dataListContact: ContactList(),
        updateProfile: [],
        result: [],
        formData: new FormData(),
        regex: new RegExp("^(\\+98|0)?9\\d{9}$"),
    }),

    actions: {
        async handelCheckDataProfile() {
            this.dataProfile.mobile = removeCodeMobile(this.dataProfile.mobile)
            if (this.dataProfile.secondPhone) {
                this.dataProfile.secondPhone = removeCodeMobile(this.dataProfile.secondPhone)
            } else {
                this.dataProfile.secondPhone = ''
            }
            if (this.dataProfile.workPhone) {
                this.dataProfile.workPhone = removeCodeMobile(this.dataProfile.workPhone)
            } else {
                this.dataProfile.workPhone = ''
            }

            if (this.dataProfile.avatar) {
                console.log(this.dataProfile.avatar);
                this.uploadAvatar.SIDAvatar = this.dataProfile.avatar
                this.uploadAvatar.srcphoto = StorageUrl + this.dataProfile.avatar
                this.uploadAvatar.changeAvatar = false
            } else {
                this.uploadAvatar.srcphoto = ''
                this.uploadAvatar.changeAvatar = true
            }
        },


        async handelSetDataProfile() {
            let data = await getIndexedDB('profile')
            data = JSON.parse(data)
            this.dataProfile = Object.assign({}, data)
            console.log(this.dataProfile);
            this.handelCheckDataProfile()
        },

        async handelUploadAvatar(dataFile: any) {
            this.formData = new FormData()
            this.uploadAvatar.loading = true
            await this.uploadAvatar.formData.append('file', dataFile.file)
            await this.uploadAvatar.formData.append('type', "image")
            this.uploadAvatar.result = await POST_UPLOAD(this.uploadAvatar.formData)

            if (this.uploadAvatar.result.status == "error") {
                this.uploadAvatar.loading = false
                this.uploadAvatar.errMessageCroper.showCardCroper = true
                this.uploadAvatar.errMessageCroper.errMessage = this.uploadAvatar.result.error.message
                setTimeout(() => {
                    this.uploadAvatar.errMessageCroper.showCardCroper = false
                    this.uploadAvatar.errMessageCroper.errMessage = ''
                }, 2000)
            } else if (this.uploadAvatar.result.status == 'success') {
                this.uploadAvatar.loading = false
                this.uploadAvatar.srcphoto = dataFile.img
                this.uploadAvatar.changeAvatar = false
                this.uploadAvatar.SIDAvatar = this.uploadAvatar.result.data.SID
                this.uploadAvatar.showCroper = false
                setTimeout(() => {
                    this.success.showCardMessage = true
                    this.success.successMessage = 'آپلود آواتار با موفقیت انجام شد'
                }, 300)
                setTimeout(() => {
                    this.success.showCardMessage = false
                    this.success.successMessage = ''
                }, 2000)
            }
        },

        async handelRemoveAvatar() {

            this.uploadAvatar.formData = new FormData()
            this.uploadAvatar.SIDAvatar = ''
            this.uploadAvatar.srcCroper = ''
            this.uploadAvatar.srcphoto = ''
            this.uploadAvatar.changeAvatar = true

        },

        async handelCheckProfileSubmited() {
            if (this.dataProfile.firstName.length <= 2) {
                this.err.errMessage = "فیلد نام حداقل ۳ کاراکتر می باشد "
                this.err.showCardMessage = true
                setTimeout(() => {
                    this.err.showCardMessage = false
                }, 2000)
            } else {
                this.err.errMessage = ''
                this.err.showCardMessage = false
            }
            if (this.dataProfile.lastName.length <= 2) {
                this.err.errMessage = "فیلد نام خانوادگی حداقل ۳ کاراکتر می باشد "
                this.err.showCardMessage = true
                setTimeout(() => {
                    this.err.showCardMessage = false
                }, 2000)
            } else {
                this.err.errMessage = ''
                this.err.showCardMessage = false
            }
            if (!this.regex.test(this.dataProfile.mobile)) {
                this.err.errMessage = "شماره تلفن خود را به درستی وارد کنید "
                this.err.showCardMessage = true
                setTimeout(() => {
                    this.err.showCardMessage = false
                }, 2000)
            } else {
                this.err.errMessage = ''
                this.err.showCardMessage = false
            }


            if (this.dataProfile.firstName.length >= 3 && this.dataProfile.lastName.length >= 3) {
                this.err.errMessage = ''
                this.err.showCardMessage = false
                this.handelSendDataProfile()
            }

        },

        async handelSendDataProfile() {
            this.loading = true
            this.formData = new FormData()
            await this.formData.append('userID', this.dataProfile.ID)
            await this.formData.append('avatar', this.uploadAvatar.SIDAvatar)
            await this.formData.append('firstName', this.dataProfile.firstName)
            await this.formData.append('lastName', this.dataProfile.lastName)
            await this.formData.append('mobile', String(this.dataProfile.mobile))
            await this.formData.append('secondPhone', this.dataProfile.secondPhone)
            await this.formData.append('homePhone', this.dataProfile.homePhone)
            await this.formData.append('workPhone', this.dataProfile.workPhone)
            await this.formData.append('job', this.dataProfile.job)
            this.result = await POST_PROFILE_UPDATE(this.formData)
            this.loading = false
            if (this.result.status == 'success') {
                this.updateProfile = await GET_PROFILE()
                await setIndexedDB('profile', JSON.stringify(this.updateProfile.data.profile))
                this.dataProfile = Object.assign({}, this.updateProfile.data.profile)
                this.handelCheckDataProfile()
                this.success.showCardMessage = true
                this.success.successMessage = 'ویرایش پروفایل با موفقیت انجام شد'
                setTimeout(() => {
                    this.success.showCardMessage = false
                    this.dataPopup.showEditProfile = false
                    this.dataPopup.showProfile = false
                    this.dataUserAuth.CheckAuthUser()
                    this.dataListContact.handelData()
                }, 2000)

            } else if (this.result.status == 'error') {
                this.err.errMessage = this.result.error.message
                this.err.showCardMessage = true
                setTimeout(() => {
                    this.err.showCardMessage = false
                }, 2000)
            }
        }
    }
})